import { Checkbox, FormField, Link, Popover, StatusIndicator, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useState } from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;



//const storeAdmin = useStoreAdmin();
export const AdminRACInvoices = () => {
    const { menu, parameters } = useGlobalState();
    const [sideOpen, setSideOpen] = useState(false);
    const [onlyErrors, setOnlyErrors] = useState(false);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [invoices, setInvoices] = useState<any[]>([]);



    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/rac/invoices/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    month: parameters.period.split("-")[1],
                    year: parameters.period.split("-")[0],
                    orderBy: "hangar",
                    order: "asc",
                    orderBy2: "dateCharge",
                    order2: "desc"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.invoices)
                setInvoices(data.invoices)

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (parameters.period) {
            handleRefresh()
        }
    }, [parameters.period]);

    useEffect(() => {
    }, []);


    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const filtered: any[] = invoices.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.RUT, item.hangar, item?.jsonSII.razonSocial, item?.total.toString()].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        const matchesSearch = searchWords.every((word) =>
            text.includes(word.toLowerCase().replace(/[^a-z0-9]/g, ""))
        );

        // Only include errors if onlyErrors = true
        const hasError =
            !onlyErrors ||
            (item.jsonRXSII?.error?.message &&
                item.jsonRXSII.error.message.toString().trim() !== "");

        return matchesSearch && hasError;
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={

                            <SpaceBetween direction="horizontal" size="xs">
                                <Favorites />
                            </SpaceBetween>
                        }>Facturación RAC</Header>


                        <Table
                            variant='embedded'
                            items={paginated}
                            filter={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <TextFilter
                                        filteringText={filterValue}
                                        filteringPlaceholder="Buscar..."
                                        onChange={({ detail }) => setFilterValue(detail.filteringText)}
                                    />
                                    <div style={{ width: 130 }}>
                                        <MPModal
                                            width={120}
                                            today prevMonth nextMonth
                                            end={new Date()}
                                            date={`${parameters.period}`}
                                            onConfirm={(date) => {
                                                setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                            }}
                                        />
                                    </div>
                                    <Checkbox
                                        disabled={!invoices.some(
                                            (invoice) =>
                                                invoice.jsonRXSII?.error?.message &&
                                                invoice.jsonRXSII.error.message.toString().trim() !== ""
                                        )}
                                        checked={onlyErrors}
                                        onChange={({ detail }) => {
                                            setOnlyErrors(detail.checked);
                                        }}
                                    > Solo errores
                                    </Checkbox>

                                </SpaceBetween>

                            }
                            cellVerticalAlign='top'


                            pagination={
                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {invoices.length > 0 && (
                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>
                            }

                            columnDefinitions={[
                                {
                                    id: "dateCharge", header: "Emisión", cell: item =>

                                        <FormField label={<>
                                            {item?.dateCharge}

                                        </>}>
                                            {item.idRentalCharge}-{item.idRental}
                                        </FormField>,
                                    minWidth: 100,

                                },
                                {
                                    id: "receptor", header: "RUT", cell: item => (
                                        <FormField label={<>
                                            {item?.jsonSII.razonSocial}

                                        </>}>
                                            {item?.jsonSII.rut}
                                        </FormField>
                                    )
                                },
                                { id: "hangar", header: "Hangar", cell: item => item?.hangar },
                                {
                                    id: "value", header: "Total", cell: item => (
                                        <>
                                            <FormField label=
                                                {Number(item?.total ?? 0).toLocaleString("es-CL")}>
                                                {item?.amount} {item?.currency}
                                            </FormField>
                                        </>
                                    )
                                },
                                {
                                    id: "status", header: "Status", cell: item => (
                                        <>{item?.isPaid === 1 && (
                                            <StatusIndicator type="info">
                                                Anticipo
                                            </StatusIndicator>
                                        )}
                                            {item.jsonRXSII.error && (
                                                <Box color="text-status-error">
                                                    <Popover
                                                        triggerType="custom"
                                                        dismissButton={false}
                                                        header="Respuesta del SII"
                                                        content={item.jsonRXSII.error.message || "Error desconocido"}
                                                    >
                                                        <StatusIndicator type="error">
                                                            Error
                                                        </StatusIndicator>
                                                    </Popover>
                                                </Box>
                                            )}
                                        </>
                                    )
                                },

                                //FEV.76820424-1.F00002457.M277
                                //FEV.76820424-1.F00002433.M251.pdf
                                //
                                //FEV.76820424-1.F00002433.M251.pdf

                                {
                                    id: "pdf",
                                    header: "",
                                    cell: (item) =>
                                        item?.jsonRXSII?.FOLIO ? (
                                            <>
                                                <SpaceBetween direction='vertical' size='xs'>
                                                    <Link
                                                        onClick={() =>
                                                            window.open(
                                                                `/storage/dte/76820424/33/FEV.76820424-1.F${String(item.jsonRXSII.FOLIO).padStart(8, "0")}.M${item?.idRentalCharge}.pdf`,
                                                                "_blank"
                                                            )
                                                        }
                                                    >
                                                        PDF
                                                    </Link>
                                                    <Link
                                                        onClick={() =>
                                                            window.open(
                                                                `/storage/dte/76820424/33/FEV.76820424-1.F${String(item.jsonRXSII.FOLIO).padStart(8, "0")}.M${item?.idRentalCharge}.pdf`,
                                                                "_blank"
                                                            )
                                                        }
                                                    >
                                                        XML
                                                    </Link>
                                                </SpaceBetween>
                                            </>
                                        ) : (
                                            ""
                                        ),
                                }
                            ]}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin facturas según criterios</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />

                    </SpaceBetween>

                </>
            }
        />);
};